import isMobile from 'is-mobile'
import type { ReactNode } from 'react'
import type { SubscriptionEntity } from '../api/service-manager.ts'
import type { UserRoleEntity } from '../api/user-manager.ts'
import { useSubscription } from '../data/service.ts'
import { currentUserData, hasRequiredRole } from '../data/userProfile.ts'
import { useFlags } from '../launchdarkly.ts'

export const Restricted = ({
	role,
	feature,
	mobile,
	flag,
	children,
	inverse,
}: RequireAtLeastOne<{
	role: UserRoleEntity['name'] | UserRoleEntity['name'][]
	feature: SubscriptionEntity['features'][number]
	mobile: boolean
	flag: (f: ReturnType<typeof useFlags>) => boolean | undefined
}> & {
	children: ReactNode
	inverse?: boolean
}) => {
	const flags = useFlags()
	const { data: currentUser } = currentUserData.use()
	const { data: subscription } = useSubscription()
	const handleInverse = (value: boolean) => (inverse ? !value : value)

	if (feature && handleInverse(!subscription.features.includes(feature))) return null
	if (role && handleInverse(!hasRequiredRole(currentUser.role, role))) return null
	if (mobile != null && handleInverse(isMobile() !== mobile)) return null
	if (flag != null && handleInverse(!flag(flags))) return null

	return children
}

type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<T, Exclude<keyof T, Keys>> &
	{ [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>> }[Keys]
